<template>
  <el-container v-loading="isLoading" class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" :content="title"></el-page-header>
    </el-header>
    <el-main class="Edit-main">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-form-item v-if="isSspUser" label="所属广告主" prop="advertiserId">
          <el-select v-model="form.advertiserId" :disabled="isModel===2" @change="setAdvertiserId">
            <el-option v-for="(item, index) in user" :label="item.advertiserName" :value="item.advertiserId" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放计划名称" prop="planName" style="width: 500px">
          <el-input v-model="form.planName"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择日期时间" value-format="timestamp"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择日期时间" value-format="timestamp"></el-date-picker>
        </el-form-item>
        <el-form-item label="投放时段">
          <div class="timeSlot">
            <ul class="timeSlot-time clearfix">
              <li>0:00</li>
              <li>2:00</li>
              <li>4:00</li>
              <li>6:00</li>
              <li>8:00</li>
              <li>10:00</li>
              <li>12:00</li>
              <li>14:00</li>
              <li>16:00</li>
              <li>18:00</li>
              <li>20:00</li>
              <li>22:00</li>
              <li>24:00</li>
            </ul>
            <div class="clearfix">
              <ul class="timeSlot-week">
                <li><el-checkbox v-model="week[0]" @change="weekSelect(0)">星期一</el-checkbox></li>
                <li><el-checkbox v-model="week[1]" @change="weekSelect(1)">星期二</el-checkbox></li>
                <li><el-checkbox v-model="week[2]" @change="weekSelect(2)">星期三</el-checkbox></li>
                <li><el-checkbox v-model="week[3]" @change="weekSelect(3)">星期四</el-checkbox></li>
                <li><el-checkbox v-model="week[4]" @change="weekSelect(4)">星期五</el-checkbox></li>
                <li><el-checkbox v-model="week[5]" @change="weekSelect(5)">星期六</el-checkbox></li>
                <li><el-checkbox v-model="week[6]" @change="weekSelect(6)">星期日</el-checkbox></li>
              </ul>
              <ul class="timeSlot-table clearfix">
                <li v-for="(item, index) in form.planCycle" :key="index" :class="item===1?'true':''" @click="timeLiSelect(index)"></li>
              </ul>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="每日预算" prop="dayBudget" style="width: 500px">
          <el-input v-model="form.dayBudget"></el-input>
        </el-form-item>
        <el-form-item label="匀速消耗">
          <el-switch v-model="form.isSpeed"></el-switch>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="width: 500px">
          <el-input type="textarea" v-model="form.remark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
          <el-button v-if="isModel!==2" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Edit',
  data () {
    let planNameRule = (rule, value, callback) => {
      if (this.isSspUser && this.form.advertiserId === '') {
        callback(new Error('请先选择所属广告主'))
      } else {
        if (value === '') {
          callback(new Error('请输入投放计划名称'))
        } else {
          if (value.length < 1 || value.length > 100) {
            callback(new Error('长度在 1 到 100 个字符'))
          } else {
            if (this.isModel !== 2 || this.oldName !== value) {
              this.$axios({
                method: 'post',
                headers: {
                  'Authorization': this.$store.state.user.token,
                  'ModuleId': this.thisModule.id
                },
                url: this.myOption.requestUrl + this.thisModule.exists,
                data: this.qs.stringify({
                  advertiserId: this.form.advertiserId,
                  planName: value
                })
              }).then((res) => {
                let code = res.data.code
                if (code === 200) {
                  if (res.data.data.exists) {
                    callback(new Error('投放计划名称已存在'))
                  } else {
                    callback()
                  }
                } else {
                  this.myOption.abnormalCode(this, code)
                }
              }).catch((err) => {
                this.myOption.abnormalCode(this, err)
              })
            } else {
              callback()
            }
          }
        }
      }
    }
    let integerRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入每日预算'))
      } else {
        if (value <= 0 || !/^[0-9]+$/.test(value)) {
          callback(new Error('请输入大于0的整数'))
        } else {
          callback()
        }
      }
    }
    return {
      id: '',
      title: '',
      user: [],
      oldName: '',
      thisModule: {},
      isSspUser: this.$store.getters.isMediaOwner,
      isModel: this.$store.getters.isEditId,
      isLoading: false,
      isShow: false,
      week: [
        false, false, false, false, false, false, false
      ],
      form: {
        planName: '',
        remark: '',
        advertiserId: '',
        startTime: '',
        endTime: '',
        dayBudget: '',
        planCycle: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
        ],
        isSpeed: false
      },
      rules: {
        planName: [
          { required: true, validator: planNameRule, trigger: 'blur' }
        ],
        advertiserId: [
          { required: true, message: '请选择所属广告主', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ],
        dayBudget: [
          { required: true, validator: integerRule, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (!this.isSspUser) {
      this.form.advertiserId = this.$store.state.user.info.advertiserId
    }
    let thisModule = this.myOption.requestModule.plan.children
    if (this.isModel === 2) {
      this.isLoading = true
      this.id = this.$store.state.user.editId
      this.title = '修改投放计划'
      this.thisModule = thisModule.modify
      this.thisModule.detail = thisModule.detail
      this.getDetail()
    } else {
      this.title = '新建投放计划'
      this.thisModule = thisModule.add
      if (this.isSspUser) {
        this.getUserList()
      }
      if (this.isModel === 3) {
        this.isLoading = true
        this.id = this.$store.state.user.editId
        this.thisModule.detail = thisModule.detail
        this.getDetail()
      }
    }
  },
  methods: {
    close () {
      this.myOption.switchListAndEdit(this, true)
    },
    // 设置广告主
    setAdvertiserId () {
      this.form.planName = ''
    },
    // 获取广告主列表
    getUserList () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.user,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.user = res.data.data.data
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 获取详情信息
    getDetail () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.detail.id
        },
        url: this.myOption.requestUrl + this.thisModule.detail.api,
        data: this.qs.stringify({
          planId: this.id
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data
          if (this.isSspUser) {
            this.form.advertiserId = data.advertiserId
            this.getUserList()
          }
          this.form.planName = data.planName
          this.oldName = data.planName
          this.form.remark = data.remark
          this.form.dayBudget = data.dayBudget
          this.form.startTime = data.startTime * 1000
          this.form.endTime = data.endTime * 1000
          this.form.isSpeed = !!data.isSpeed
          let arr = data.planCycle.split('')
          let week = [
            true, true, true, true, true, true, true
          ]
          for (let key in arr) {
            arr[key] = (arr[key]) * 1
            if (!arr[key]) {
              if (key <= 23) {
                week[0] = false
              } else if (key <= 47) {
                week[1] = false
              } else if (key <= 71) {
                week[2] = false
              } else if (key <= 95) {
                week[3] = false
              } else if (key <= 119) {
                week[4] = false
              } else if (key <= 143) {
                week[5] = false
              } else if (key <= 167) {
                week[6] = false
              }
            }
          }
          this.form.planCycle = arr
          this.week = week
          this.isLoading = false
        } else {
          this.myOption.abnormalCode(this, code)
          this.isLoading = false
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let param = {
            planName: this.form.planName,
            remark: this.form.remark,
            startTime: this.form.startTime ? this.form.startTime * 1 / 1000 : null,
            endTime: this.form.endTime ? this.form.endTime * 1 / 1000 : null,
            planCycle: this.form.planCycle.join(''),
            dayBudget: this.form.dayBudget || null,
            isSpeed: this.form.isSpeed * 1
          }
          if (this.isSspUser) {
            param.advertiserId = this.form.advertiserId
          }
          if (this.isModel === 2) {
            param.planId = this.id
          }
          this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.api,
            data: this.qs.stringify(param)
          }).then((res) => {
            let code = res.data.code
            this.isLoading = false
            if (code === 200) {
              this.$message.success(`${this.isModel === 2 ? '修改' : '新建'}投放计划成功`)
              this.$router.push({path: this.$route.path.replace('/edit', '/list')})
            } else {
              this.myOption.abnormalCode(this, code)
            }
          }).catch((err) => {
            this.isLoading = false
            this.myOption.abnormalCode(this, err)
          })
        } else {
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    // 时间段选择
    timeLiSelect (index) {
      let arr = JSON.parse(JSON.stringify(this.form.planCycle))
      arr[index] = (!arr[index]) * 1
      this.form.planCycle = arr
      let a = 0
      let b = 0
      let c = 0
      let e = true
      if (index <= 23) {
        b = 23
      } else if (index <= 47) {
        a = 24
        b = 47
        c = 1
      } else if (index <= 71) {
        a = 48
        b = 71
        c = 2
      } else if (index <= 95) {
        a = 49
        b = 95
        c = 3
      } else if (index <= 119) {
        a = 96
        b = 119
        c = 4
      } else if (index <= 143) {
        a = 120
        b = 143
        c = 5
      } else if (index <= 167) {
        a = 144
        b = 167
        c = 6
      }
      for (let i = a; i <= b; i++) {
        if (!arr[i]) {
          e = false
          break
        }
      }
      let arr2 = JSON.parse(JSON.stringify(this.week))
      arr2[c] = e
      this.week = arr2
    },
    // 星期选择
    weekSelect (index) {
      const ble = this.week[index] ? 1 : 0
      let arr = JSON.parse(JSON.stringify(this.form.planCycle))
      let a = 0
      let b = 0
      if (index === 0) {
        b = 23
      } else if (index === 1) {
        a = 24
        b = 47
      } else if (index === 2) {
        a = 48
        b = 71
      } else if (index === 3) {
        a = 72
        b = 95
      } else if (index === 4) {
        a = 96
        b = 119
      } else if (index === 5) {
        a = 120
        b = 143
      } else if (index === 6) {
        a = 144
        b = 167
      }
      for (let i = a; i <= b; i++) {
        arr[i] = ble
      }
      this.form.planCycle = arr
    },
    // 区间计算
    timeSection (index) {

    }
  },
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  }
}
</script>

<style scoped>
  .timeSlot{
    width: 740px;
    height: 250px;
    background-color: #eee;
    border: 1px solid #DCDFE6;
  }
  .timeSlot-time{
    display: block;
    margin-left: 84px;
    width: 100%;
  }
  .timeSlot-time>li{
    float: left;
    width: 50px;
  }
  .timeSlot-week{
    float: left;
    width: 100px;
    height: 175px;
  }
  .timeSlot-week>li{
    float: left;
    padding-left: 15px;
    width: 100%;
    height: 25px;
    line-height: 25px;
  }
  .timeSlot-table{
    box-sizing: content-box;
    float: left;
    width: 600px;
    height: 175px;
    border-style: solid;
    border-color: #999;
    border-width: 1px 0 0 1px;
  }
  .timeSlot-table>li{
    float: left;
    box-sizing: border-box;
    width: 25px;
    height: 25px;
    border-style: solid;
    border-color: #999;
    border-width: 0 1px 1px 0;
    background-color: #fff;
    cursor: pointer;
  }
  .timeSlot-table>li.true{
    background-color: #a4da89;
  }
  .timeSlot-table>li:hover{
    border: 1px dashed #e43937;
  }
</style>



// WEBPACK FOOTER //
// src/components/plan/Edit.vue